import { combineReducers } from 'redux';
import formsReducer from 'reducers/modules/forms';
import { reducer as formReducer } from 'redux-form';


export default combineReducers({
	form: formReducer,
	forms: formsReducer,
});
